import { FC, memo } from 'react'
import { ButtonProps } from '@chakra-ui/react'

import { ButtonWithPermission } from 'components/validators'
import { Pencil } from 'components/icons'

type Props = ButtonProps & {
  permissions?: (string | undefined)[]
  customDisableCondition?: boolean
  customTooltipLabel?: string
  children: string
}

const UpdateButtonWithPermission: FC<Props> = ({
  customTooltipLabel,
  customDisableCondition,
  permissions,
  children,
  ...buttonProps
}) => {
  return (
    <ButtonWithPermission
      customTooltipLabel={customTooltipLabel}
      customDisableCondition={customDisableCondition}
      permissions={permissions}
      leftIcon={<Pencil />}
      {...buttonProps}
    >
      {children}
    </ButtonWithPermission>
  )
}

export default memo(UpdateButtonWithPermission)
